import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
export default {
  methods: _objectSpread({}, mapActions('d2admin/fullscreen', ['toggle']))
};